var formatPhoneNumber = function (value) {
    var onlyNumberValue = value.replace(/\D+/g, "");
    if ((onlyNumberValue === null || onlyNumberValue === void 0 ? void 0 : onlyNumberValue.length) === 10) {
        var formattedValue = onlyNumberValue.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        if (!formattedValue) {
            return onlyNumberValue;
        }
        return formattedValue;
    }
    return onlyNumberValue;
};
export default formatPhoneNumber;
